<template lang="pug">
  #hair-color-compare.hair-color-compare.container.text-center
    .row.xs-f-small.lg-f-medium.max-at-tweak
      .hair-color-compare-wrap.fixed-width-tweak-upper.xs-text-left.md-text-center.bg-gray-light
        button.intro.btn-reset(@click="open = !open" :class="{open: open}")
          span.xs-f-xlarge.max-at-tweak Make A Color Comparison
          span.icon-caret-down.xs-f-xxlarge.lg-f-xxxlarge.max-at-tweak
        p.compare-text.xs-f-small.lg-f-medium.max-at-tweak.xs-pb-150m
          | Compare up to 4 shades to find your favorite.&nbsp;
          br.xs-hide.md-hide
          | Choose from any of the shades below.

        .shade-comparer(:class="{open: open}")
          .shades.text-center.xs-pb-100m
            .shade(v-for="product in compareProducts")
              template(v-if="product")
                .prod-image.a-box-xs-1x1
                  .a-box-content
                    img(:src="getObjProperty(product, 'imagery.toneSwatch.url')" :alt="getObjProperty(product, 'imagery.toneSwatch.alt_text')")
                    button.remove.btn-reset.icon-x.color-white.xs-f-large.max-at-tweak(@click="remove(getObjProperty(product, 'code'))")
                      span.ada-tooltip remove
                
                .prod-info
                  a.see-details.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:href="'/product/' + getObjProperty(product, 'url_key')") see details
                  p.upper.bold.xs-f-xxsmall.lg-f-xsmall.max-at-tweak.xs-pt-50m {{ getObjProperty(product, 'name') }}
                  p.prod-desc.xs-f-xxsmall.lg-f-xsmall.max-at-tweak {{ getObjProperty(product, 'desc.short') }}
                  button.btn-link.xs-f-xxsmall.lg-f-xsmall.max-at-tweak(@click="tryItOn(product)") Try It On
              
              template(v-else)
                router-link.empty-box(to='/hair-color-chart#color-chart' aria-label="scroll to hair colors")
                  span.hv-center.light.xs-f-xxxlarge.max-at-tweak +

</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  export default {
    name: "HairColorCompare",
    emits: ['update:modelValue'],

    props: {
      modelValue: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        open: false
      };
    },

    inject: ['getObjProperty'],

    computed: {
      compareProducts() {
        var products = [];

        for (var x = 0; x < 4; x++) {
          if (this.modelValue[x]) {
            products.push(this.modelValue[x]);
          } else {
            products.push(null);
          }
        }

        return products;
      }
    },

    methods: {
      ...mapActions('pdp', [
        'openPlaygroundModal',
        'getProductByUrlKey'
      ]),

      remove(productCode) {
        var newValue = [];
        
        this.modelValue.forEach(product => {
          if (product.code != productCode) {
            newValue.push(product);
          }
        });

        this.$emit('update:modelValue', newValue);
      },

      tryItOn(product) {
        this.getProductByUrlKey(this.getObjProperty(product, 'url_key')).then(() => {
          this.openPlaygroundModal();
        }).catch((e) => console.error(e));
      }
    },

    watch: {
      compareProducts() {
        this.open = true;
      }
    }
  };
</script>

<style scoped lang="stylus">
  .hair-color-compare
    .hair-color-compare-wrap
      padding 0 3%
    
    .intro
      position relative
      width 100%
      text-align left
      padding-left 3%
      padding-right 3em
      margin 1em 0
      
      .icon-caret-down
        position absolute
        top 0
        right 0.5em
        display inline-block
        transition(transform 350ms ease)
        
      &.open
        .icon-caret-down
          transform(rotate(-180deg))
    
    .compare-text
      padding-left 3%
      
    .shade-comparer
      max-height 0
      overflow hidden
      transition(max-height 400ms ease-in-out)
      
      &.open
        max-height 65em

      .btn-link        
        text-decoration underline
      
      .shade
        display inline-block
        vertical-align top
        width 9.5em
        min-height 10em
        margin 0.5em
        
        .prod-image
          img
            width 100%
            vertical-align top
            
          .remove
            position absolute
            top 0.25em
            right 0.25em
            background-color color-slate
            border-radius 50%
            text-align center
            
        .prod-info
          .prod-desc
            padding 0 5%
            
          .see-details
            padding 0.75em 0
            
      
      .empty-box
        position relative
        display inline-block
        width 9.5em
        height 9.5em
        border 1px solid color-gray-triple-nines
        color color-gray-triple-nines
        
    @media mq-tablet
      .hair-color-compare-wrap
        padding 0 12%
        
      .shade-comparer
        .shade
          width 10em
          margin 0.75em
          
        .empty-box
          width 10em
          height 10em
          
    @media mq-desktop-md-plus
      .intro
        text-align center
        padding 0 5%
        
      .compare-text
        padding-left 0
        
      .shade-comparer
        &.open
          max-height 45em
          
        .shade
          width 10em
          margin 0.75em
          
        .empty-box
          width 10em
          height 10em
        
</style>

